{
    "StatvaluestypeLabel": "Sortie pour les champs pourcentage, date\/heure et durée :",
    "StatvaluestypeBothOptionLabel": "[Double valeurs (formaté + brut)]",
    "StatvaluestypeMainOptionLabel": "Valeur d'affichage formatée uniquement (texte)",
    "StatvaluestypeAlternateOptionLabel": "Valeur brute uniquement (pour l'utilisation de graphiques et de formules)",
    "CSVExportFormat_SectionHeader": "Format d'exportation CSV \/ XLS",
    "CSVExportFormat_SectionPara": "Vous pouvez ajuster la façon dont les valeurs statistiques de pourcentage, de date\/heure et de durée sont générées dans les rapports exportés au format CSV et XLS.",
    "NAME": "CSVExportFormat"
}